export default '/opt/build/repo/packages/app/node_modules/sql.js/dist'